import "../css/about.css";

import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

function AboutUs() {
  const projectMembers = [
    {
      name: "Fernando Etcheverry",
      comment: "",
      photo: "DSC00771.jpg",
      linkedin: "https://www.linkedin.com/in/fernando-etcheverry-/",
      github: "https://github.com/FernandoEtcheverry",
    },
    {
      name: "Rosina González",
      comment: "",
      photo: "foto-Rosina.jpg",
      linkedin: "https://www.linkedin.com/in/rosinagonzalez/",
      github: "https://github.com/rosinagonzalez",
    },
    {
      name: "Fabricio Guido",
      comment: "",
      photo: "Fabricio.jpg",
      linkedin: "https://www.linkedin.com/in/fabricio-guido-cruz/",
      github: "https://github.com/Fabricio-Guido",
    },
  ];
  return (
    <div>
      <Navbar />
      <div className="heading_container container mt-5">
        <h1 className="text-center mb-4 mt-5">ABOUT SUPERPOWER</h1>
        <h2 className="pt-2 text-center pb-2 fs-3 fw-normal">Project members</h2>
        <div className="row g-5 members">
          {projectMembers.map((member) => (
            <div className="col-md-4 text-center">
              <img
                src={process.env.REACT_APP_IMG_BASE_URL + member.photo}
                alt="member"
                className="member-photo w-75 rounded-circle pb-2"
              />
              <p className="fs-5 py-0S memberName">{member.name}</p>
              {/* <p className="text-muted">{member.comment}</p> */}
              <div className="pt-0">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1 fs-4 text-dark"
                >
                  <i className="bi bi-linkedin"></i>
                </a>
                <a
                  href={member.github}
                  target="_blank"
                  rel="noreferrer"
                  className="mx-1 fs-4 text-dark"
                >
                  <i className="bi bi-github"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
        <h2 className="pt-2 pb-2 fs-3 fw-normal">About this project</h2>
        <div className="mb-3">
          SuperPower is our final project for Hack Academy's Coding Bootcamp, which took place
          between January and April, 2022. For this project we had 3 weeks to create an E-Commerce
          from scratch, in which we had to apply what we had learnt about Front-End and Back-End
          developing throughout the course of our 3-month bootcamp experience.
        </div>
        <div className="mb-3">
          The Front-End is divided in two parts: customer and admin. The former (this site) is a
          website where the user can surf and add products to the shopping cart without the
          necessity of being registered. Once they want to proceed to checkout a customer must{" "}
          <Link to="/login">log in</Link>. In addition to this, every logged user can access to
          their personal order history and edit their account information. If the visitor does not
          have an account, they can create one at any time <Link to="/register">here</Link>. On the
          admin side, the user must be logged in to make use of its features. The administrator has
          the power to create, modify and delete products and categories, as well as adding and
          removing other admins. Also they have access to the customers and orders list.
        </div>
        <div className="mb-3">
          In regards to the Back-End, it consists on a simple RESTful API (
          <a href={`${process.env.REACT_APP_API_URL}`} target="_blank">
            link
          </a>
          ) which provides the aforementioned websites with the information they need to perform
          their typical operations. The API is connected to a SQL database with tables describing
          the different product categories, products, registered customers, orders and
          administrators that exist on the site.
        </div>
        <div className="mb-3">
          As far as challenges concerned, time was of the essence, therefore we had to be as much
          organized as possible. We assigned individual and shared tasks using Trello, where we
          planned and registered what each of us was doing in order to maximize our efficency.
        </div>
        <div className="row">
          <h3 className="my-2 fs-4">Technologies used:</h3>
          <div className="col">
            <ul className="list-unstyled">
              <li className="pb-1">
                <i className="fab fa-js"></i> Javascript
              </li>
              <li className="pb-1">
                <i className="fab fa-css3"></i> CSS
              </li>
              <li className="pb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <path d="M 3.125 1 C 2.219 1 1.5030625 1.4805 1.1640625 2.3125 C 1.0570625 2.5695 1.0029531 2.8420469 1.0019531 3.1230469 C 1.0009531 4.0540469 1.6009375 4.8097188 1.9609375 5.2617188 C 2.0239375 5.3407187 2.080625 5.4110938 2.140625 5.4960938 L 2.3027344 5.7109375 C 2.4637344 5.9219375 2.6470781 6.16125 2.7050781 6.28125 C 2.7240781 6.33625 2.7492031 6.4326875 2.7832031 6.5546875 C 2.9402031 7.1196875 3.2332187 8.16975 3.6992188 8.96875 C 3.8872187 9.29075 4.1517969 9.6954687 4.3417969 9.9804688 C 4.2147969 10.616469 4 11.788 4 12.5 C 4 13.75 4.2592188 14.753875 4.8242188 15.671875 C 5.0332187 15.999875 5.671 17 6.75 17 C 7.133 17 7.7694062 16.850391 7.9414062 15.900391 C 8.7064063 16.887391 10 18.125 12 19 C 12 19 8.2507969 14.625438 7.5917969 11.898438 C 7.5917969 11.898437 6.874625 12.625375 6.265625 14.109375 C 6.083625 13.651375 6 13.135 6 12.5 C 6 11.873 6.2758125 10.471375 6.3828125 9.984375 L 6.4765625 9.5605469 L 6.2304688 9.203125 C 6.2264687 9.196125 5.7227344 8.4688906 5.4277344 7.9628906 C 5.0917344 7.3868906 4.8439375 6.4955781 4.7109375 6.0175781 C 4.6459375 5.7845781 4.594875 5.6159531 4.546875 5.5019531 C 4.371875 5.1229531 4.115625 4.7900937 3.890625 4.4960938 L 3.765625 4.3300781 C 3.702625 4.2390781 3.6193906 4.133625 3.5253906 4.015625 C 3.3423906 3.785625 3.0017188 3.3570312 3.0117188 3.0820312 L 3.1230469 3.0039062 L 3.125 3 C 3.92 3 4.9440781 3.5643437 5.3300781 3.7773438 C 5.4560781 3.8463438 5.5486563 3.8940156 5.5976562 3.9160156 L 5.7714844 3.9921875 L 6.1132812 4.0039062 C 6.5602813 4.0139062 7.9189063 4.0456875 8.8789062 4.4296875 C 10.629906 5.1296875 11.598031 5.830375 12.582031 7.109375 C 14.906031 10.131375 15.763484 14.044984 15.771484 14.083984 L 15.896484 14.648438 L 16.443359 14.826172 C 16.462359 14.833172 17.992922 15.344641 19.419922 16.681641 C 17.624922 17.125641 17 18 17 18 C 17 18 17.476 18.928 19.75 20.375 C 21.125 21.25 21.875 21.875 23 23 C 23 23 21.875688 20.499813 20.304688 18.507812 C 21.500687 18.124813 22.970703 17.925781 22.970703 17.925781 L 22.060547 16.664062 C 20.562547 14.587063 18.553656 13.538859 17.597656 13.130859 C 17.265656 11.864859 16.262969 8.614625 14.167969 5.890625 C 12.968969 4.331625 11.693094 3.3993125 9.6210938 2.5703125 C 8.3940937 2.0803125 6.9187188 2.0218594 6.2617188 2.0058594 C 5.6867187 1.6898594 4.409 1 3.125 1 z M 7.1875 5 C 7.1875 5 6.75 5 6.25 5.125 L 7.625 6.9980469 C 8 6.5000469 8 5.9179688 8 5.9179688 C 8 5.9179688 7.7505 5.25 7.1875 5 z"></path>
                </svg>{" "}
                MySQL
              </li>
              <li className="pb-1">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  role="img"
                  viewBox="0 0 24 24"
                  width="1em"
                  height="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M23.5594 14.7228a.5269.5269 0 0 0-.0563-.1191c-.139-.2632-.4768-.3418-1.0074-.2321-1.6533.3411-2.2935.1312-2.5256-.0191 1.342-2.0482 2.445-4.522 3.0411-6.8297.2714-1.0507.7982-3.5237.1222-4.7316a1.5641 1.5641 0 0 0-.1509-.235C21.6931.9086 19.8007.0248 17.5099.0005c-1.4947-.0158-2.7705.3461-3.1161.4794a9.449 9.449 0 0 0-.5159-.0816 8.044 8.044 0 0 0-1.3114-.1278c-1.1822-.0184-2.2038.2642-3.0498.8406-.8573-.3211-4.7888-1.645-7.2219.0788C.9359 2.1526.3086 3.8733.4302 6.3043c.0409.818.5069 3.334 1.2423 5.7436.4598 1.5065.9387 2.7019 1.4334 3.582.553.9942 1.1259 1.5933 1.7143 1.7895.4474.1491 1.1327.1441 1.8581-.7279.8012-.9635 1.5903-1.8258 1.9446-2.2069.4351.2355.9064.3625 1.39.3772a.0569.0569 0 0 0 .0004.0041 11.0312 11.0312 0 0 0-.2472.3054c-.3389.4302-.4094.5197-1.5002.7443-.3102.064-1.1344.2339-1.1464.8115-.0025.1224.0329.2309.0919.3268.2269.4231.9216.6097 1.015.6331 1.3345.3335 2.5044.092 3.3714-.6787-.017 2.231.0775 4.4174.3454 5.0874.2212.5529.7618 1.9045 2.4692 1.9043.2505 0 .5263-.0291.8296-.0941 1.7819-.3821 2.5557-1.1696 2.855-2.9059.1503-.8707.4016-2.8753.5388-4.1012.0169-.0703.0357-.1207.057-.1362.0007-.0005.0697-.0471.4272.0307a.3673.3673 0 0 0 .0443.0068l.2539.0223.0149.001c.8468.0384 1.9114-.1426 2.5312-.4308.6438-.2988 1.8057-1.0323 1.5951-1.6698zM2.371 11.8765c-.7435-2.4358-1.1779-4.8851-1.2123-5.5719-.1086-2.1714.4171-3.6829 1.5623-4.4927 1.8367-1.2986 4.8398-.5408 6.108-.13-.0032.0032-.0066.0061-.0098.0094-2.0238 2.044-1.9758 5.536-1.9708 5.7495-.0002.0823.0066.1989.0162.3593.0348.5873.0996 1.6804-.0735 2.9184-.1609 1.1504.1937 2.2764.9728 3.0892.0806.0841.1648.1631.2518.2374-.3468.3714-1.1004 1.1926-1.9025 2.1576-.5677.6825-.9597.5517-1.0886.5087-.3919-.1307-.813-.5871-1.2381-1.3223-.4796-.839-.9635-2.0317-1.4155-3.5126zm6.0072 5.0871c-.1711-.0428-.3271-.1132-.4322-.1772.0889-.0394.2374-.0902.4833-.1409 1.2833-.2641 1.4815-.4506 1.9143-1.0002.0992-.126.2116-.2687.3673-.4426a.3549.3549 0 0 0 .0737-.1298c.1708-.1513.2724-.1099.4369-.0417.156.0646.3078.26.3695.4752.0291.1016.0619.2945-.0452.4444-.9043 1.2658-2.2216 1.2494-3.1676 1.0128zm2.094-3.988-.0525.141c-.133.3566-.2567.6881-.3334 1.003-.6674-.0021-1.3168-.2872-1.8105-.8024-.6279-.6551-.9131-1.5664-.7825-2.5004.1828-1.3079.1153-2.4468.079-3.0586-.005-.0857-.0095-.1607-.0122-.2199.2957-.2621 1.6659-.9962 2.6429-.7724.4459.1022.7176.4057.8305.928.5846 2.7038.0774 3.8307-.3302 4.7363-.084.1866-.1633.3629-.2311.5454zm7.3637 4.5725c-.0169.1768-.0358.376-.0618.5959l-.146.4383a.3547.3547 0 0 0-.0182.1077c-.0059.4747-.054.6489-.115.8693-.0634.2292-.1353.4891-.1794 1.0575-.11 1.4143-.8782 2.2267-2.4172 2.5565-1.5155.3251-1.7843-.4968-2.0212-1.2217a6.5824 6.5824 0 0 0-.0769-.2266c-.2154-.5858-.1911-1.4119-.1574-2.5551.0165-.5612-.0249-1.9013-.3302-2.6462.0044-.2932.0106-.5909.019-.8918a.3529.3529 0 0 0-.0153-.1126 1.4927 1.4927 0 0 0-.0439-.208c-.1226-.4283-.4213-.7866-.7797-.9351-.1424-.059-.4038-.1672-.7178-.0869.067-.276.1831-.5875.309-.9249l.0529-.142c.0595-.16.134-.3257.213-.5012.4265-.9476 1.0106-2.2453.3766-5.1772-.2374-1.0981-1.0304-1.6343-2.2324-1.5098-.7207.0746-1.3799.3654-1.7088.5321a5.6716 5.6716 0 0 0-.1958.1041c.0918-1.1064.4386-3.1741 1.7357-4.4823a4.0306 4.0306 0 0 1 .3033-.276.3532.3532 0 0 0 .1447-.0644c.7524-.5706 1.6945-.8506 2.802-.8325.4091.0067.8017.0339 1.1742.081 1.939.3544 3.2439 1.4468 4.0359 2.3827.8143.9623 1.2552 1.9315 1.4312 2.4543-1.3232-.1346-2.2234.1268-2.6797.779-.9926 1.4189.543 4.1729 1.2811 5.4964.1353.2426.2522.4522.2889.5413.2403.5825.5515.9713.7787 1.2552.0696.087.1372.1714.1885.245-.4008.1155-1.1208.3825-1.0552 1.717-.0123.1563-.0423.4469-.0834.8148-.0461.2077-.0702.4603-.0994.7662zm.8905-1.6211c-.0405-.8316.2691-.9185.5967-1.0105a2.8566 2.8566 0 0 0 .135-.0406 1.202 1.202 0 0 0 .1342.103c.5703.3765 1.5823.4213 3.0068.1344-.2016.1769-.5189.3994-.9533.6011-.4098.1903-1.0957.333-1.7473.3636-.7197.0336-1.0859-.0807-1.1721-.151zm.5695-9.2712c-.0059.3508-.0542.6692-.1054 1.0017-.055.3576-.112.7274-.1264 1.1762-.0142.4368.0404.8909.0932 1.3301.1066.887.216 1.8003-.2075 2.7014a3.5272 3.5272 0 0 1-.1876-.3856c-.0527-.1276-.1669-.3326-.3251-.6162-.6156-1.1041-2.0574-3.6896-1.3193-4.7446.3795-.5427 1.3408-.5661 2.1781-.463zm.2284 7.0137a12.3762 12.3762 0 0 0-.0853-.1074l-.0355-.0444c.7262-1.1995.5842-2.3862.4578-3.4385-.0519-.4318-.1009-.8396-.0885-1.2226.0129-.4061.0666-.7543.1185-1.0911.0639-.415.1288-.8443.1109-1.3505.0134-.0531.0188-.1158.0118-.1902-.0457-.4855-.5999-1.938-1.7294-3.253-.6076-.7073-1.4896-1.4972-2.6889-2.0395.5251-.1066 1.2328-.2035 2.0244-.1859 2.0515.0456 3.6746.8135 4.8242 2.2824a.908.908 0 0 1 .0667.1002c.7231 1.3556-.2762 6.2751-2.9867 10.5405zm-8.8166-6.1162c-.025.1794-.3089.4225-.6211.4225a.5821.5821 0 0 1-.0809-.0056c-.1873-.026-.3765-.144-.5059-.3156-.0458-.0605-.1203-.178-.1055-.2844.0055-.0401.0261-.0985.0925-.1488.1182-.0894.3518-.1226.6096-.0867.3163.0441.6426.1938.6113.4186zm7.9305-.4114c.0111.0792-.049.201-.1531.3102-.0683.0717-.212.1961-.4079.2232a.5456.5456 0 0 1-.075.0052c-.2935 0-.5414-.2344-.5607-.3717-.024-.1765.2641-.3106.5611-.352.297-.0414.6111.0088.6356.1851z"></path>
                </svg>{" "}
                PostgreSQL
              </li>
              <li className="pb-1">
                <i className="fa-brands fa-node-js"></i> Node.js
              </li>
              <li className="pb-1">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  role="img"
                  viewBox="0 0 24 24"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title></title>
                  <path d="M21.362 9.354H12V.396a.396.396 0 0 0-.716-.233L2.203 12.424l-.401.562a1.04 1.04 0 0 0 .836 1.659H12v8.959a.396.396 0 0 0 .716.233l9.081-12.261.401-.562a1.04 1.04 0 0 0-.836-1.66z"></path>
                </svg>{" "}
                Supabase
              </li>
              <li className="pb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <path fill="currentColor" d="M24 22.525H0l12-21.05l12 21.05z" />
                </svg>{" "}
                Vercel
              </li>
            </ul>
          </div>
          <div className="col">
            <ul className="list-unstyled">
              <li className="pb-1">
                <i className="fa-brands fa-react"></i> React.js
              </li>
              <li className="pb-1">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  role="img"
                  viewBox="0 0 24 24"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16.634 16.504c.87-.075 1.543-.84 1.5-1.754-.047-.914-.796-1.648-1.709-1.648h-.061a1.71 1.71 0 00-1.648 1.769c.03.479.226.869.494 1.153-1.048 2.038-2.621 3.536-5.005 4.795-1.603.838-3.296 1.154-4.944.93-1.378-.195-2.456-.81-3.116-1.799-.988-1.499-1.078-3.116-.255-4.734.6-1.17 1.499-2.023 2.099-2.443a9.96 9.96 0 01-.42-1.543C-.868 14.408-.416 18.752.932 20.805c1.004 1.498 3.057 2.456 5.304 2.456.6 0 1.23-.044 1.843-.194 3.897-.749 6.848-3.086 8.541-6.532zm5.348-3.746c-2.32-2.728-5.738-4.226-9.634-4.226h-.51c-.253-.554-.837-.899-1.498-.899h-.045c-.943 0-1.678.81-1.647 1.753.03.898.794 1.648 1.708 1.648h.074a1.69 1.69 0 001.499-1.049h.555c2.309 0 4.495.674 6.488 1.992 1.527 1.005 2.622 2.323 3.237 3.897.538 1.288.509 2.547-.045 3.597-.855 1.647-2.294 2.517-4.196 2.517-1.199 0-2.367-.375-2.967-.644-.36.298-.96.793-1.394 1.093 1.318.598 2.652.943 3.94.943 2.922 0 5.094-1.647 5.919-3.236.898-1.798.824-4.824-1.47-7.416zM6.49 17.042c.03.899.793 1.648 1.708 1.648h.06a1.688 1.688 0 001.648-1.768c0-.9-.779-1.647-1.693-1.647h-.06c-.06 0-.15 0-.226.029-1.243-2.098-1.768-4.347-1.572-6.772.12-1.828.72-3.417 1.797-4.735.9-1.124 2.593-1.68 3.747-1.708 3.236-.061 4.585 3.971 4.689 5.574l1.498.45C17.741 3.197 14.686.62 11.764.62 9.02.62 6.49 2.613 5.47 5.535 4.077 9.43 4.991 13.177 6.7 16.174c-.15.195-.24.539-.21.868z"></path>
                </svg>{" "}
                Redux
              </li>
              <li className="pb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  width="1em"
                  height="1em"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M24 18.588a1.529 1.529 0 0 1-1.895-.72l-3.45-4.771l-.5-.667l-4.003 5.444a1.466 1.466 0 0 1-1.802.708l5.158-6.92l-4.798-6.251a1.595 1.595 0 0 1 1.9.666l3.576 4.83l3.596-4.81a1.435 1.435 0 0 1 1.788-.668L21.708 7.9l-2.522 3.283a.666.666 0 0 0 0 .994l4.804 6.412zM.002 11.576l.42-2.075c1.154-4.103 5.858-5.81 9.094-3.27c1.895 1.489 2.368 3.597 2.275 5.973H1.116C.943 16.447 4.005 19.009 7.92 17.7a4.078 4.078 0 0 0 2.582-2.876c.207-.666.548-.78 1.174-.588a5.417 5.417 0 0 1-2.589 3.957a6.272 6.272 0 0 1-7.306-.933a6.575 6.575 0 0 1-1.64-3.858c0-.235-.08-.455-.134-.666A88.33 88.33 0 0 1 0 11.577zm1.127-.286h9.654c-.06-3.076-2.001-5.258-4.59-5.278c-2.882-.04-4.944 2.094-5.071 5.264z"
                  />
                </svg>{" "}
                Express
              </li>
              <li className="pb-1">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  role="img"
                  viewBox="0 0 24 24"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12.0264 0 1.5947 5.9922v12.0156L12.0264 24l10.3789-5.9922V5.9922L12.0264 0zm-.0274 3.4844 7.4297 4.2266v8.5781l-7.4297 4.2266-7.3476-4.1817-.0801-8.623 7.4277-4.2266zm.0489.5898c-.9765.5627-1.9519 1.1274-2.9277 1.6914v.2539l2.6074 1.5234v.4824c.1355-.0781.2616-.1511.4023-.2324l.2559.1504v-.3359c.8844-.5068 1.8073-1.0412 2.5684-1.4805.0035-.1232.0027-.2534.0039-.373-.9703-.5596-1.9403-1.1197-2.9102-1.6797zM8.335 6.1387c-.9705.553-1.9312 1.1228-2.8926 1.6914v3.4023c.965.5553 1.9287 1.1127 2.8926 1.6699l.4023-.2324v-2.916c.8561-.4945 1.7522-1.0126 2.4902-1.4395v-.4843L8.335 6.1387zm7.4433.0879-2.8926 1.6699v.3379l2.6367 1.541v3.0664c.0854.0494.1705.0991.2559.1484l2.8926-1.6699V7.918l-2.8926-1.6914zm-3.6484 2.1445c-.9636.5584-1.9281 1.1151-2.8926 1.6719v3.4238c.965.5553 1.9287 1.1127 2.8926 1.6699l2.8926-1.6719v-3.4023l-2.8926-1.6914zm-6.1973 3.7227c-.1627.0962-.3275.1889-.4902.2852v3.4023c.9643.5571 1.9284 1.1145 2.8926 1.6719l.4023-.2324v-2.918c.1625-.0939.3086-.1787.4727-.2734-.1629-.0945-.3047-.1763-.4727-.2734v-.508l-.4023.2325c-.8251-.4771-1.6902-.976-2.4024-1.3867zm12.2481.0859-2.4023 1.3887c-.088-.0509-.1672-.0972-.2559-.1484v.334l-.4922.2852.4922.2871v3.0664c.0854.0494.1705.0991.2559.1484l2.8926-1.6719v-3.4023l-.4903-.2872zm-8.4688 2.1387c-.1581.0913-.3165.1821-.4746.2734v3.4238c.9637.5575 1.9282 1.1136 2.8926 1.6699l2.8926-1.6699v-3.4023l-.4902-.2871-2.4023 1.3887c-.8307-.4804-1.7013-.9829-2.4181-1.3965z"></path>
                </svg>{" "}
                Sequelize
              </li>
              <li className="pb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.2em"
                  height="1.2em"
                  viewBox="0 0 172 172"
                >
                  <g
                    strokeWidth="1"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit="10"
                  >
                    <path d="M0,172v-172h172v172z" fill="none"></path>
                    <g fill="#000000">
                      <path d="M78.4965,113.84967l9.32025,-9.761l9.31667,9.761v40.23367h-18.63692z"></path>
                      <path d="M63.55758,104.1245l13.27625,-2.41875l1.80242,13.373l-23.65,32.551l-15.07508,-10.95783z"></path>
                      <path d="M57.19717,87.46558l12.15825,5.848l-6.39983,11.87875l-38.26642,12.43058l-5.75842,-17.72317z"></path>
                      <path d="M61.834,70.25842l6.39983,11.87875l-12.15825,5.848l-38.26642,-12.43417l5.75842,-17.72675z"></path>
                      <path d="M75.7015,59.0605l-1.80242,13.373l-13.27625,-2.41875l-23.65,-32.551l15.07867,-10.95425z"></path>
                      <path d="M93.5035,58.15033l-9.32025,9.761l-9.31667,-9.761v-40.23367h18.63692z"></path>
                      <path d="M108.43883,67.87908l-13.27267,2.41875l-1.80242,-13.373l23.64642,-32.551l15.07867,10.95425z"></path>
                      <path d="M114.80642,84.53083l-12.16183,-5.848l6.39983,-11.87875l38.26642,-12.43058l5.75842,17.72317z"></path>
                      <path d="M110.166,101.74158l-6.39983,-11.87875l12.15825,-5.84442l38.26642,12.43058l-5.75842,17.72675z"></path>
                      <path d="M96.2985,112.9395l1.806,-13.373l13.27267,2.41875l23.65,32.551l-15.07867,10.95425z"></path>
                    </g>
                  </g>
                </svg>
                JSON Web Token
              </li>
              <li className="pb-1">
                <i className="bi bi-bootstrap"></i> Bootstrap
              </li>
              <li className="pb-1">
                <i className="bi bi-three-dots"></i> Among others
              </li>
            </ul>
          </div>
        </div>

        <h2 className="pt-3 pb-1 fs-3 fw-normal">Credentials</h2>
        <p>For full access to all user features use these credentials:</p>
        <div className="row pb-5">
          <div className="col-lg-5 col-sm-6 mb-3">
            <h4 className="fs-5">Customer:</h4>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">URL:</p>{" "}
              <a className="ps-1" href="/" target="_blank">
                superpower-user.vercel.app
              </a>
            </div>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">Email:</p> <a className="ps-1">customer@customer.com</a>
            </div>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">Password:</p> <a className="ps-1">CUSTOMER123</a>
            </div>
          </div>
          <div className="col-lg-5 col-sm-6 mb-3">
            <h4 className="fs-5">Admin:</h4>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">URL:</p>{" "}
              <a className="ps-1" href={process.env.REACT_APP_ADMIN_URL} target="_blank">
                {process.env.REACT_APP_ADMIN_URL.slice(8)}
              </a>
            </div>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">Email:</p> <a className="ps-1">admin@admin.com</a>
            </div>
            <div className="d-flex align items center">
              <p className="my-0 fw-bold">Password:</p> <a className="ps-1">ADMIN123</a>
            </div>
          </div>
        </div>

        {/* <h3>How to use the site:</h3>
        <div className="mb-3">
          <span className=" fw-bold">Customers page</span> (<a href="/">superpower.com</a>): This is
          the current site we are in. Many of its functionalities are not available for unregistered
          users. All new visitors can register a new customer if they'd like to, but if they find it
          simpler there is a default customer already registered on the site which anyone can make
          use of. The corresponding e-mail and password are{" "}
          <span className="fw-bold">customer@gmail.com</span> and{" "}
          <span className="fw-bold">CUSTOMER1234</span>.
        </div>
        <div className="mb-3">
          <span className="text-decoration-underline">Administrators page</span> (
          <a href={process.env.REACT_APP_ADMIN_URL}>{process.env.REACT_APP_ADMIN_URL.slice(7)}</a>):
          With the exception of the login, all functionalities of this site are unavailable unless
          one is logged in as an administrator. By default there is a user of this kind already
          created on the site, and every visitor can make use of it if they would like to explore
          the page. The corresponding e-mail and password are{" "}
          <span className="fw-bold">admin@gmail.com</span> and{" "}
          <span className="fw-bold">ADMIN</span>.
        </div> */}
      </div>

      <Footer />
    </div>
  );
}

export default AboutUs;
